// Mock data for LA-KliN website

export const mockServices = {
  cleaning: [
    {
      id: 1,
      name: "Residential Cleaning",
      description: "Professional home cleaning services tailored to your family's needs",
      features: ["Regular maintenance", "Deep cleaning", "Eco-friendly products", "Flexible scheduling"]
    },
    {
      id: 2,
      name: "Commercial Cleaning",
      description: "Comprehensive cleaning solutions for offices and retail spaces",
      features: ["Daily maintenance", "Window cleaning", "Carpet care", "Sanitization services"]
    },
    {
      id: 3,
      name: "Deep Cleaning",
      description: "Intensive cleaning for move-ins, renovations, or special occasions",
      features: ["Complete sanitization", "Equipment disinfection", "Detailed surface cleaning", "Post-construction cleanup"]
    }
  ],
  security: [
    {
      id: 4,
      name: "Security Guards",
      description: "Highly trained security personnel for your premises",
      features: ["24/7 availability", "Vetted professionals", "Emergency response", "Detailed reporting"]
    },
    {
      id: 5,
      name: "Alarm Systems",
      description: "Advanced security technology to protect your property",
      features: ["Motion detection", "Remote monitoring", "Mobile alerts", "Professional installation"]
    },
    {
      id: 6,
      name: "Event Security",
      description: "Specialized security services for events and gatherings",
      features: ["Crowd management", "Access control", "Risk assessment", "Coordination with authorities"]
    },
    {
      id: 7,
      name: "Property Monitoring",
      description: "Continuous surveillance and protection services",
      features: ["CCTV monitoring", "Patrol services", "Incident response", "Detailed reports"]
    }
  ]
};

export const mockTestimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    position: "Property Manager",
    company: "Sandton Residential Estate",
    text: "La-Klin has transformed our estate management. Having both security and cleaning from one provider has streamlined our operations and reduced costs significantly.",
    rating: 5
  },
  {
    id: 2,
    name: "David Oosthuizen",
    position: "Facilities Director",
    company: "Cape Town Corporate Centre",
    text: "The 24/7 reliability and professionalism of La-Klin's team gives us complete peace of mind. Our offices are always secure and spotless.",
    rating: 5
  },
  {
    id: 3,
    name: "Nomsa Khumalo",
    position: "Operations Manager",
    company: "Johannesburg Retail Complex",
    text: "La-Klin's integrated approach to security and cleaning has improved our brand reputation and customer experience immensely.",
    rating: 5
  }
];

export const mockQuoteRequests = [];

export const mockContactSubmissions = [];

export const mockCompanyInfo = {
  name: "La-Klin Security & Cleaning Services",
  tagline: "Safety and Cleanliness, Seamlessly Delivered",
  phone: "+27 11 234 5678",
  whatsapp: "+27 11 234 5678",
  address: "123 Business District, Johannesburg, South Africa",
  hours: "24/7 Emergency Response | Office Hours: Mon-Fri 8AM-6PM",
  provinces: ["Gauteng", "Western Cape", "KwaZulu-Natal", "Eastern Cape", "Limpopo", "North West"]
};